import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import Breadcrumb from "components/LM/common/Breadcrumb";
import { Form, Card, Button, ButtonToolbar } from "react-bootstrap";

const MAX_ALLOWED_MERGE = 5;

function VoiceMergeForm(props) {
  const { onStartMerge, setVoiceIds, voiceIds } = props;

  const [query, setQuery] = useState("");
  const history = useHistory();

  useEffect(() => {
    if (voiceIds.length > 0) {
      setQuery(voiceIds.join('\n'));
      onStartMerge(true);
    }
  }, [onStartMerge, voiceIds]);

  const onInputChange = (newQuery) => {
    setQuery(newQuery);
  }

  const onSubmit = async (ev) => {
    ev.preventDefault();
    const voiceIds = getIdsFromQuery(query);
    if (!voiceIds.length) return;
    onStartMerge(true);
    setVoiceIds(voiceIds);
    history.push(`/voices/merge?ids=${voiceIds.join(',')}`);
  };

  const queryLength = getIdsFromQuery(query).length;

  return (
    <div className="mergevoice-search-form">
      <Breadcrumb items={['Voices', 'Merge']} />
      <Form>
        <Card>
          <Card.Header>
            <Card.Title tag="h5">Enter a list of Voice Ids here, one voice per line (max. {MAX_ALLOWED_MERGE}):</Card.Title>
          </Card.Header>
          <Card.Body>
            <Form.Group className="mb-3" controlId="inSearchMergeVoices">
              <Form.Control as="textarea" rows="5" onChange={(ev) => { onInputChange(ev.target.value) }} value={(query == null) ? '' : query} />
            </Form.Group>
            <ButtonToolbar>
              <Button
                color="info"
                type="submit"
                className="mr-1 mb-1"
                onClick={(ev) => { onSubmit(ev) }}
                disabled={!query || queryLength <= 1 || queryLength > MAX_ALLOWED_MERGE}
              >
                Search Merge Candidates
              </Button>
            </ButtonToolbar>
          </Card.Body>
        </Card>
      </Form>
    </div >
  );
}

function getIdsFromQuery(query) {
  const ids = query.split(/\n+/).filter(id => id.length > 0);
  return [...new Set(ids)];
}

export default VoiceMergeForm;
